module.exports = __webpack_public_path__ + "img/main-bg.370e3a18.png";